import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { FileDataMySuffixService } from './file-data-my-suffix.service';

@Component({
    selector: 'jhi-file-data-my-suffix-delete-dialog',
    templateUrl: './file-data-my-suffix-delete-dialog.component.html'
})
export class FileDataMySuffixDeleteDialogComponent {
    fileData: IFileDataMySuffix;

    constructor(
        private fileDataService: FileDataMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute,

    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.fileDataService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'fileDataListModification',
                content: 'Deleted an fileData'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-file-data-my-suffix-delete-popup',
    template: ''
})
export class FileDataMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ fileData }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(FileDataMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.fileData = fileData;
                this.ngbModalRef.result.then(
                    result => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    },
                    reason => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
